import {flavorDescriptions, colors, strokeWidth} from '../constants';

import {
  createPoint,
  buildGeometryInstance,
  isSameCoordinatePair,
  getLayerForFlavoredEntityType,
  handleAddCorrectnessIcon,
  hasCoords
} from './entities.utils';

const segment = {
  /**
   * @example
   * const entity = {
   *   type: 'segment',
   *   elements: {
   *     points: [
   *       [0, 0],
   *       [4, 1]
   *     ]
   *   },
   *   flavor: 'studentGuess'
   * };
   */

  create({board, entity, onClick}) {
    const {
      elements: {points},
      flavor
    } = entity;

    const linePoints = points.map((coords) => createPoint({board, coords, flavor}));

    const {color} = flavorDescriptions[flavor];

    const line = board.create('line', linePoints, {
      strokeWidth,
      highlightStrokeWidth: strokeWidth,
      straightFirst: false,
      straightLast: false,
      strokeColor: color,
      highlightStrokeColor: color,
      layer: getLayerForFlavoredEntityType('line', flavor),
      tabindex: null
    });

    const correctnessIcon = handleAddCorrectnessIcon({board, flavor, coords: points[0]});

    return buildGeometryInstance({
      board,
      entity,
      geometryElement: line,
      constituentElements: [...linePoints, line],
      onClick,
      correctnessIcon
    });
  },
  createPartial({board, partialInstance, coords, flavor}) {
    if (!partialInstance) {
      return {
        entity: {
          type: 'segment',
          elements: {
            points: []
          },
          flavor
        },
        geometryElements: [],
        done: false,
        remove() {
          return null;
        }
      };
    }

    const isValid = !hasCoords(partialInstance.entity.elements, coords);

    if (!isValid) return null;

    const points = [...partialInstance.entity.elements.points, coords];
    const nextPoint = createPoint({board, coords, flavor});
    const geometryElements = [...partialInstance.geometryElements, nextPoint];
    return {
      entity: {
        type: 'segment',
        elements: {
          points
        },
        flavor
      },
      geometryElements,
      done: points.length === 2,
      instructions: 'Complete the segment by placing a second point.',
      handleCursorMove(cursorCoords) {
        if (board.elementsByName.previewSegment) {
          board.removeAncestors(board.elementsByName.previewSegment);
        }

        if (!coords || !cursorCoords || isSameCoordinatePair(coords, cursorCoords)) {
          return;
        }

        board.create('line', [coords, cursorCoords], {
          name: 'previewSegment',
          strokeWidth,
          highlightStrokeWidth: strokeWidth,
          strokeColor: colors.preview,
          highlightStrokeColor: colors.preview,
          dash: 3,
          straightFirst: false,
          straightLast: false,
          tabindex: null
        });
      },
      remove() {
        geometryElements.forEach((element) => board.removeAncestors(element));
        return null;
      }
    };
  }
};

export default segment;
